// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Isaias (Isaiah)",
  bookSlug: "isaias",
  chapter: 31,
  argument: "The folly of trusting to Egypt, and forgetting God. He will fight for his people against the Assyrians.",
  verses: [
    { n: 1, text: "Woe to them that go down to Egypt for help, trusting in horses, and putting their confidence in chariots, because they are many; and in horsemen, because they are very strong; and have not trusted in the holy One of Israel, and have not sought after the Lord." },
    { n: 2, text: "But he that is the wise one hath brought evil, and hath not removed his words: and he will rise up against the house of the wicked, and against the aid of them that work iniquity." },
    { n: 3, text: "Egypt is man, and not God: and their horses, flesh, and not spirit: and the Lord shall put down his hand, and the helper shall fall, and he that is helped shall fall, and they shall all be confounded together." },
    { n: 4, text: "For thus saith the Lord to me: Like as the lion roareth, and the lion's whelp upon his prey, and when a multitude of shepherds shall come against him, he will not fear at their voice, nor be afraid of their multitude: so shall the Lord of hosts come down to fight upon Mount Sion, and upon the hill thereof." },
    { n: 5, text: "As birds flying, so will the Lord of hosts protect Jerusalem, protecting and delivering, passing over and saving." },
    { n: 6, text: "Return as you had deeply revolted, O children of Israel." },
    { n: 7, text: "For in that day a man shall cast away his idols of silver, and his idols of gold, which your hands have made for you to sin." },
    { n: 8, text: "And the Assyrian shall fall by the sword, not of a man; and the sword, not of a man, shall devour him; and he shall flee not at the face of the sword: and his young men shall be tributaries:" },
    { n: 9, text: "And his strength shall pass away with dread, and his princes fleeing shall be afraid: the Lord hath said it, whose fire is in Sion, and his furnace in Jerusalem." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Chariots. He continues to inveigh against this practice, chap. xxx. 16. (Calmet) — Salmanasar will ruin the ten tribes.", attribution: "Menochius" }
    ] },
    { verse: 2, notes: [
      { text: "Words. The Lord will punish the wicked Jews, (Calmet) after the Egyptians. (Josephus, [Jewish Antiquities?] x. 1.) — The former would not believe the prophets.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Hand. If God neglect to support empires, they fall of themselves.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Thereof. He will thence hurl destruction on the distant enemy. (Calmet) — He had destroyed Sennacherib's army, 4 Kings xix. Yet they forgot this and other proofs of God's power and love.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Over. He will protect Jerusalem, notwithstanding the menaces of Sennacherib, as he did his people from the destroying angel.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Revolted. Let your conversion bear proportion (Calmet) with your sins.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Idols. Their worship was afterwards more severely prohibited, chap. xxx. 21.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Flee not. Hebrew, \"flee to himself,\" lo. Septuagint and Vulgate have read la, \"not.\" The angel destroyed the army, and the king was slain at his return. — Tributaries. Ninive being afterwards subject to the Chaldeans, &c. (Calmet) — Hebrew, \"shall melt.\"", attribution: "Vatable" }
    ] },
    { verse: 9, notes: [
      { text: "Strength. Hebrew, \"rock,\" the king. — Jerusalem, to protect it, (Calmet) and punish the guilty.", attribution: "Chaldean" }
    ] },
  ],
};

export default chapter;
